var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',[_c('circle',{attrs:{"cx":6,"cy":6,"r":6,"fill":_vm.color,"opacity":1}}),_c('path',{attrs:{"fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }